/**
 * A mixin to help with remembering page Y-scroll position.
 *
 * How to use:
 *
 * The page component this is used on should have a unique route name
 * associated with it. This mixin will then automatically store the
 * Y scroll position when routing elsewhere and apply it when coming
 * back. We can also check if if we have been here before, which can
 * be handy to call related initialization/reset logic.
 */
const rememberPageScrollPos = {
  computed: {
    routeName() {
      return this.$route.name;
    },
    cache() {
      return this.$store.state.common.lastScrollPositionByRoute;
    },
    isFirstTimeVisitingRoute() {
      const history = this.$store.state.common.routeHistory;
      const previousRoutes = history.slice(0, history.length - 1);
      const firstTimeVisit =
        previousRoutes.filter((route) => route.name === this.routeName)
          .length === 0;
      return firstTimeVisit;
    },
  },
  methods: {
    applyLastScrollPosition() {
      const lastScrollPosition = this.cache[this.routeName];
      if (lastScrollPosition) {
        window.scrollTo(0, lastScrollPosition);
      }
    },
    rememberLastScrollPosition() {
      const payload = {
        routeName: this.routeName,
        scrollPos: window.pageYOffset,
      };
      this.$store.commit('SET_LAST_SCROLL_POSITION_FOR_ROUTE', payload);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.applyLastScrollPosition();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.rememberLastScrollPosition();
    next();
  },
};

export default rememberPageScrollPos;



// WEBPACK FOOTER //
// ./src/mixins/rememberPageScrollPos.js